import { render, staticRenderFns } from "./expertData.vue?vue&type=template&id=60e49fd3&scoped=true&"
import script from "./expertData.vue?vue&type=script&lang=js&"
export * from "./expertData.vue?vue&type=script&lang=js&"
import style0 from "./expertData.vue?vue&type=style&index=0&id=60e49fd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e49fd3",
  null
  
)

export default component.exports